import React, {Component} from "react";
import PropTypes from 'prop-types';

class Child extends Component{

    render() {
        const {
            children,
        } = this.props;

        return (
            <React.Fragment>
                {children}
            </React.Fragment>
        )
    }

}


Child.propTypes = {
    type: PropTypes.string,
};

Child.defaultProps = {
    type:""
};

export default Child

